import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Products = {
  List: lazyNamed(() => import('./containers/ProductsList/index.tsx'), 'ProductsList'),
  Edit: lazyNamed(() => import('./containers/ProductEdit/index.tsx'), 'ProductForm'),
  History: lazyNamed(() => import('./containers/ProductHistory.tsx'), 'ProductHistory'),
};
